export function Module(name) {
  return function (target) {
    target.module = name;
  }
}

export function Component(name, options) {
  return function (target) {
    const component = Object.assign({}, options, { controller: target });

    angular
      .module(target.module)
      .component(name, component);
  }
}

export function Directive(name, options) {
  return function(target) {
    const directive = Object.assign({}, options, { controller: target });

    angular
      .module(target.module)
      .directive(name, () => directive);
  }
}

export function Controller(name) {
  return function(target) {
    angular
      .module(target.module)
      .controller(name, target);
  }
}

export function Service(name) {
  return function (target) {
    angular
      .module(target.module)
      .service(name, target);
  }
}

export function Factory(name) {
  return function (target) {
    angular
      .module(target.module)
      .factory(name, target);
  }
}

/*
 * Decorator to do automatic .bind(this) on selected methods.
 */
export function bindToClass(target, key, descriptor) {
  let method = descriptor.value;
  let definingProperty = false;

  return {
    configurable: true,
    get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof method !== 'function') {
        return method;
      }

      let boundFn = method.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get() {
          return boundFn;
        },
        set(value) {
          method = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set(value) {
      method = value;
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/decorators.ts